import React, { useEffect, useState } from 'react';
export function Timer() {
  const [timeLeft, setTimeLeft] = useState({
    d: 5,
    h: 19,
    m: 9,
    s: 0
  });
  useEffect(() => {
    let timer: NodeJS.Timeout;
    const timeout = setTimeout(() => {
      timer = setInterval(() => {
        setTimeLeft(prev => {
          let {
            d,
            h,
            m,
            s
          } = prev;
          if (s > 0) s--;else {
            s = 59;
            if (m > 0) m--;else {
              m = 59;
              if (h > 0) h--;else {
                h = 23;
                if (d > 0) d--;
              }
            }
          }
          return {
            d,
            h,
            m,
            s
          };
        });
      }, 1000);
    }, 2500);
    return () => {
      clearTimeout(timeout);
      if (timer) clearInterval(timer);
    };
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="bg-[#0c0c0c] py-12 px-6 text-center" data-id="element-309">
      <p className="text-[12px] text-brand-red font-bold tracking-[1px] uppercase mb-2.5" data-id="element-310">
        ⚠️ Precio de lanzamiento — cierra en:
      </p>

      <div className="flex justify-center items-center gap-1.5 mb-2" data-id="element-311">
        <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-312">
          {pad(timeLeft.d)}
        </div>
        <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-313">
          :
        </span>
        <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-314">
          {pad(timeLeft.h)}
        </div>
        <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-315">
          :
        </span>
        <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-316">
          {pad(timeLeft.m)}
        </div>
        <span className="text-[32px] font-bold text-brand-red leading-none" data-id="element-317">
          :
        </span>
        <div className="bg-black text-brand-red font-display text-[36px] font-bold py-2.5 px-4 rounded-lg min-w-[64px] text-center border-2 border-brand-red/30 leading-none" data-id="element-318">
          {pad(timeLeft.s)}
        </div>
      </div>

      <p className="text-[12px] text-brand-red font-bold tracking-[1px] uppercase mt-2" data-id="element-319">
        ⚠️ Después sube $8.000 ARS. No vuelve.
      </p>

      <div className="max-w-[400px] mx-auto mt-5" data-id="element-320">
        <div className="flex justify-between text-[12px] text-brand-muted mb-1.5" data-id="element-321">
          <span data-id="element-322">Cupos al precio de lanzamiento</span>
          <span data-id="element-323">Quedan pocos</span>
        </div>
        <div className="bg-[#222] rounded-full h-2 overflow-hidden" data-id="element-324">
          <div className="bg-gradient-to-r from-brand-green to-brand-greenSoft h-full w-[68%] rounded-full" data-id="element-325"></div>
        </div>
        <p className="text-[11px] text-brand-red font-bold text-center mt-1.5 tracking-[1px] uppercase" data-id="element-326">
          ⚠️ 68% de los cupos ya tomados
        </p>
      </div>
    </div>;
}